import React, { Component } from "react";
import ContentLoader from "react-content-loader";

export default class Loader extends Component {
    render() {
        const { height = "100%", width = "100%", x = 0, y = 0 } = this.props;

        return (
            <div className="loading">
                <ContentLoader width="100%" height={height}>
                    <rect width={width} height={height} x={x} y={y} />
                </ContentLoader>
            </div>
        );
    }
}
